import { render } from "./SnackBar.vue?vue&type=template&id=a6630d96&scoped=true"
import script from "./SnackBar.vue?vue&type=script&lang=js"
export * from "./SnackBar.vue?vue&type=script&lang=js"

import "./SnackBar.vue?vue&type=style&index=0&id=a6630d96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6630d96"],['__file',"src/components/shared/SnackBar/SnackBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6630d96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6630d96', __exports__)) {
    api.reload('a6630d96', __exports__)
  }
  
  module.hot.accept("./SnackBar.vue?vue&type=template&id=a6630d96&scoped=true", () => {
    api.rerender('a6630d96', render)
  })

}


export default __exports__